import { memo, useCallback, useEffect, useState, useRef } from 'react';
import { styled } from '@mui/material/styles';
import {
    Box,
    Checkbox,
    FormControl,
    FormGroup,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    Switch,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography, Autocomplete, ClickAwayListener, FormControlLabel, RadioGroup, Radio
} from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { makeStyles } from '@mui/styles';
import { getAllReports, getReportsList } from '../../../config/services/reports';

import { ReactComponent as DropDownIcon2 } from "../../../assets/icons/icon-angle-down-2.svg";
import { ReactComponent as ChipCancelIcon } from '../../../assets/icons/icon-fieldwells-chip-cancel.svg';
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg";
import { ReactComponent as IconVisible } from "../../../assets/icons/icon-visible.svg";
import { ReactComponent as IconNonVisible } from "../../../assets/icons/icon-non-visible.svg";
import { ReactComponent as IconAlignmentLeft } from "../../../assets/icons/icon-alignment-left2.svg";
import { ReactComponent as IconAlignmentCenter } from "../../../assets/icons/icon-alignment-center2.svg";
import { ReactComponent as IconAlignmentRight } from "../../../assets/icons/icon-alignment-right2.svg";
import { ReactComponent as IconLabelInfo } from "../../../assets/icons/icon-variable-info.svg";
import {ReactComponent as IconFilterItemAdd } from '../../../assets/icons/icon-fieldwells-add.svg';
import { ReactComponent as CheckBoxCheckedIcon } from '../../../assets/icons/icon-checkbox-checked.svg';
import { ReactComponent as CheckBoxIcon } from '../../../assets/icons/icon-checkbox-unchecked.svg';
import { SwitchButton } from '../../../utils/Reusables';

import { useDispatch, useSelector } from 'react-redux';
import { reportActions } from '../../../redux/reducers/report/reportReducer';
import CustomSelect from '../Common/CustomSelect';
import CustomMultiSelect from '../Common/CustomMultiSelect';


const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
    },
}));

const useStyles = makeStyles((theme) => ({
    fieldMenu: {
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    },
    fieldBtn: {
        position: 'absolute',
        right: '5px',
        bottom: '3px',
        cursor: 'pointer',
    },
    reportFieldList: {
        width: '100%',
        backgroundColor: '#fff',
        maxHeight: '350px',
        minHeight: '350px',
        overflowY: 'auto',
        marginBottom: '1rem',
    },
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    reportSettingsSection: {

    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }

}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const ReportSettingsTab = ({handleReportLimit, limitValue}) => {
    const classes = useStyles()
    const [expanded, setExpanded] = useState(null);
    const [linkableReports, setLinkableReports] = useState([])
    const reportDetails = useSelector(state => state.reportDetails)
    const dispatch = useDispatch();
    const linkReportRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [hasAbsoluteValue, setHasAbsoluteValue] = useState(false);
    const [mobileHasSameWebSettings, setMobileHasSameWebSettings] = useState(true);
    const [axisSettingsOpenStatus, setAxisSettingsOpenStatus] = useState(true);
    const [XAxisSettingsOpenStatus, setXAxisSettingsOpenStatus] = useState(true);
    const [YaxisSettingsOpenStatus, setYAxisSettingsOpenStatus] = useState(false);
    const [yAxisValueType, setYAxisValueType] = useState('Single');

    useEffect(() => {
        if (!linkableReports?.length) {
            getAllReports()
                .then(response => {
                    if (response?.data?.statusCode === 0) {
                        return
                    }

                    let filtered = [];
                    if (response?.result?.length) {
                        filtered = response?.result.filter(report => report?.reportName !== reportDetails?.reportDetails?.reportName)
                    }
                    setLinkableReports(filtered ?? [])
                })
        }
    }, []);

    const handleFieldChange = (event, fieldIndex, type) => {
        let value = event?.target ? event.target.value : event
        //console.log(value)
        dispatch(reportActions.updateFieldProperties({ type: type, value: value, fieldIndex: fieldIndex }))
        return
    }

    const handleFilterClose = useCallback(() => {
        //setAnchorEl(null);
        //setExpanded(false);
    })

    const handleFilterOpen = useCallback((e, panel) => {
        if(expanded){
            if(expanded !== panel) {
                setAnchorEl(e);
                setExpanded(panel);
            } else {
                setAnchorEl(null);
                setExpanded(false);
            }
        } else {
            setAnchorEl(e);
            setExpanded(panel ? panel : false);
        }
    })


    return <RootStyle>
        <Box width="100%" height="100%" className={classes.reportSettingsSection}>
            <Box className="report-settingsTab">
                <Grid container alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h4" component="div" className="re-edit-settings-input-label">Link Report</Typography>
                        <Box className="re-form-multiselect-wrapper" ref={linkReportRef}>
                            <Autocomplete
                                multiple
                                id="link-report-multi-select"
                                className='re-form-multiselect'
                                options={linkableReports}
                                getOptionLabel={(option) => option.reportName}
                                defaultValue={reportDetails?.linkedReports}
                                popupIcon={<DropDownIcon2 />}
                                disablePortal={true}
                                onOpen={() => {linkReportRef?.current?.classList.add("linkreport-opened")}}
                                onClose={() => {linkReportRef?.current?.classList.remove("linkreport-opened")}}
                                ChipProps={{
                                    deleteIcon: <ChipCancelIcon />
                                }}
                                //open={true}
                                //onChange={}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder='Select'
                                />
                                )}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Box className='re-edit-settings-divider'></Box>
                <Grid container alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h4" component="div" className="re-edit-settings-input-label">Field Settings</Typography>
                    </Grid>
                    <ClickAwayListener onClickAway={handleFilterClose}>
                        <Box className='width-100 re-edit-settings-filters'>
                            {
                                reportDetails.fields && reportDetails.fields.map((field, index) => (
                                    
                                    <Box key={`Field-${field.member}`}  className='re-edit-settings-filter' >
                                        <Box className='re-edit-settings-filter-box'   >
                                            <Box className="re-edit-settings-filter-heading">
                                                <Box className={`re-edit-settings-filter-label ` +  ((expanded === field?.member) ? `filter-opened` : ``)}> {field.displayName} </Box>
                                                {
                                                    expanded === field.member && (
                                                        <IconButton className={`re-edit-settings-filter-visibility ` + (expanded ? `show`: ``)} onClick={e => handleFieldChange(e, index, 'hide')}>
                                                            {
                                                                field.hidden ? <IconNonVisible />  : <IconVisible />
                                                            }
                                                        </IconButton>
                                                    )
                                                }  
                                                <Box className={`re-edit-settings-filter-icon ` + ((expanded === field?.member) ? `filter-opened` : ``)} 
                                                    onClick={e => handleFilterOpen(e, field?.member)} ><DropDownIcon2 /></Box>  
                                            </Box>
                                                                            
                                        </Box>
                                    
                                        <Box className={`re-edit-settings-filter-content ` + ((expanded === field?.member) ? `show` : ``)}>
                                            <Grid className='field-details'>
                                                <Box className='re-edit-settings-filter-content-item'>
                                                    <TextField
                                                        name={'title'}
                                                        className="re-form-input mb-0"
                                                        value={field.displayName}
                                                        onChange={e => handleFieldChange(e, index, 'title')}
                                                    />
                                                </Box>
                                                <Box className='re-edit-settings-filter-content-item f-r-sb'>
                                                    <Box>
                                                        <Box className='re-edit-settings-filter-content-item-label'>Alignment</Box>
                                                        <ToggleButtonGroup
                                                            value={field.align}
                                                            exclusive
                                                            onChange={(e, newAlignment) => handleFieldChange(newAlignment, index, 'align')}
                                                            aria-label="text alignment"
                                                            className='re-edit-settings-filter-aligment'
                                                        >
                                                            <ToggleButton value="left" aria-label="left aligned">
                                                                <IconAlignmentLeft />
                                                            </ToggleButton>
                                                            <ToggleButton value="center" aria-label="centered">
                                                                <IconAlignmentCenter />
                                                            </ToggleButton>
                                                            <ToggleButton value="right" aria-label="right aligned">
                                                                <IconAlignmentRight />
                                                            </ToggleButton>
                                                        </ToggleButtonGroup>
                                                    </Box>
                                                    <Box>
                                                        <Box className='re-edit-settings-filter-content-item-label'>Width</Box>
                                                        <TextField
                                                            className='re-edit-settings-filter-content-item-input'
                                                            onChange={e => handleFieldChange(e, index, 'width')}
                                                            value={field.width}
                                                            //helperText="Total width of all columns should not exceed 90"
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                        />
                                                        <Box className='re-edit-settings-filter-content-item-input-info'>Total width</Box>
                                                    </Box>
                                                </Box>
                                                <Box className='re-edit-settings-filter-content-item'>
                                                    <Box className='re-edit-settings-filter-content-item-label-main'>
                                                        <Box>Hyperlink <IconLabelInfo className='re-edit-settings-filter-content-item-label-about' /></Box>
                                                        <Box><IconFilterItemAdd className='re-edit-settings-filter-content-item-link-icon' /></Box>
                                                    </Box>
                                                    <Box className='re-edit-settings-filter-content-item-link' onClick={() => null}>+ Add Hyperlink</Box>
                                                    
                                                </Box>
                                                <Box className='re-edit-settings-filter-content-item'>
                                                    <Box className='re-edit-settings-filter-content-item-label-main'>
                                                        <Box>Metrics <IconLabelInfo className='re-edit-settings-filter-content-item-label-about' /></Box>
                                                        <Box><IconFilterItemAdd className='re-edit-settings-filter-content-item-link-icon' /></Box>
                                                    </Box>
                                                    <Box className='re-edit-settings-filter-content-item-link' onClick={() => null}>+ Add Metrics</Box>
                                                    
                                                </Box>
                                                <Box className='re-edit-settings-filter-content-item'>
                                                    <Box className='re-edit-settings-filter-content-item-label-main'>
                                                        <Box>Concat <IconLabelInfo className='re-edit-settings-filter-content-item-label-about' /></Box>
                                                        <Box>
                                                            <Switch
                                                                checked={field.concatFlag ? true : false}
                                                                onChange={e => handleFieldChange(e, index, 'concatFlag')}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    {
                                                        field.concatFlag && (
                                                            <Box className='re-edit-settings-filter-content-item-options'>

                                                                <CustomMultiSelect label="Select Field"
                                                                    isComponentReady={(expanded === field?.member)}
                                                                    selectIndex={index}
                                                                    selectType={'concatWith'}
                                                                    value={field.concatWith}
                                                                    options={reportDetails.fields.filter(fieldObj => fieldObj.member != field.member)} 
                                                                    handleSelectedValue={(e) => handleFieldChange({target: {value: e}}, index, 'concatWith')}
                                                                    optionsLabels={{label: 'displayName', value: 'member', }}
                                                                 />
                                                                <TextField
                                                                    name={'delimiter'}
                                                                    placeholder='Enter Delimiter'
                                                                    className="re-form-input mb-0"
                                                                    value={field.delimiter ?? ','}
                                                                    onChange={e => handleFieldChange(e, index, 'delimiter')}
                                                                />
                                                            </Box>
                                                        )
                                                    }
                                                    
                                                </Box>

                                                <Box className='re-edit-settings-filter-content-item'>
                                                    <Box className='re-edit-settings-filter-content-item-label-main'>
                                                        <Box>Truncate <IconLabelInfo className='re-edit-settings-filter-content-item-label-about' /></Box>
                                                        <Box>
                                                            <Switch
                                                                checked={field.truncate ? true : false}
                                                                onChange={e => handleFieldChange(e, index, 'truncate')}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    {
                                                        field.truncate && (
                                                            <Box className='re-edit-settings-filter-content-item-options'>

                                                                <TextField
                                                                    name={'truncateWith'}
                                                                    placeholder='Truncate With'
                                                                    className="re-form-input"
                                                                    value={field.truncateWith ?? ','}
                                                                    onChange={e => handleFieldChange(e, index, 'truncateWith')}
                                                                />
                                                                
                                                                <TextField
                                                                    className="re-form-input mb-0"
                                                                    placeholder={'Truncate Word Limit'}
                                                                    name={'truncateCount'}
                                                                    value={field.truncateCount ?? 5}
                                                                    onChange={e => handleFieldChange(e, index, 'truncateCount')}
                                                                />

                                                            </Box>
                                                        )
                                                    }
                                                    
                                                </Box>
                                               
                                                {
                                                    ['time', 'number', 'count'].indexOf(field.type) > -1 && (
                                                        <>
                                                        <Box className='re-edit-settings-filter-content-item'>
                                                            <Box className='re-edit-settings-filter-content-item-label-main'>
                                                                <Box>Format </Box>
                                                            </Box>
                                                            {
                                                                ['number', 'count'].indexOf(field.type) > -1 && (
                                                                    <Box className='re-edit-settings-filter-content-item-options'>

                                                                        <CustomSelect
                                                                            isComponentReady={(expanded === field?.member)}
                                                                            label='Format'
                                                                            value={field.format}
                                                                            handleSelectedValue={e => handleFieldChange({target: {value: e}}, index, 'format')}
                                                                            optionLabels={{label: 'label', value: 'value'}}
                                                                            options={[
                                                                                {label: 'Number', value: 'number'},
                                                                                {label: 'Compact Number', value: 'compactNumber'},
                                                                                {label: 'Percent', value: 'percent'},
                                                                                {label: 'Hours', value: 'hour'},
                                                                                {label: 'Minutes', value: 'minute'},
                                                                                {label: 'Seconds', value: 'second'},
                                                                                {label: 'Currency (INR)', value: 'INR'},
                                                                                {label: 'Currency (USD)', value: 'USD'},
                                                                                {label: 'Compact Currency (INR)', value: 'compactINR'},
                                                                                {label: 'Compact Currency (USD)', value: 'compactUSD'},
                                                                            ]}
                                                                        />
                                                                        
                                                                        

                                                                    </Box>
                                                                )
                                                            }

                                                            {
                                                                field.type === 'time' && (
                                                                    <CustomSelect
                                                                        isComponentReady={(expanded === field?.member)}
                                                                        label='Format'
                                                                        value={field.format}
                                                                        handleSelectedValue={e => handleFieldChange({target: {value: e}}, index, 'format')}
                                                                        optionLabels={{label: 'label', value: 'value'}}
                                                                        options={[
                                                                            {label: 'DD-MM-YYYY', value: 'DD-MM-YYYY'},
                                                                            {label: 'DD-MM-YYYY h:mm A', value: 'DD-MM-YYYY h:mm A'},
                                                                            {label: 'YYYY-MM-DD', value: 'YYYY-MM-DD'},
                                                                            {label: 'YYYY-MM-DD h:mm A', value: 'YYYY-MM-DD h:mm A'},
                                                                            {label: 'DD/MM/YYYY', value: 'DD/MM/YYYY'},
                                                                            {label: 'DD/MM/YYYY h:mm A', value: 'DD/MM/YYYY h:mm A'},
                                                                            {label: 'MMMM Do YYYY', value: 'MMMM Do YYYY'},
                                                                            {label: 'MMMM Do YYYY h:mm A', value: 'MMMM Do YYYY h:mm A'},
                                                                            {label: 'DD MMMM, YYYY', value: 'DD MMMM, YYYY'},
                                                                            {label: 'DD MMMM, YYYY h:mm A', value: 'DD MMMM, YYYY h:mm A'},
                                                                            {label: 'Do MMMM, YYYY', value: 'Do MMMM, YYYY'},
                                                                            {label: 'Do MMMM, YYYY h:mm A', value: 'Do MMMM, YYYY h:mm A'},
                                                                            {label: 'DD MMM, YYYY', value: 'DD MMM, YYYY'},
                                                                            {label: 'DD MMM, YYYY h:mm A', value: 'DD MMM, YYYY h:mm A'},
                                                                            {label: 'DD MMM, YY', value: 'DD MMM, YY'},
                                                                            {label: 'DD MMM, YY h:mm A', value: 'DD MMM, YY h:mm A'},
                                                                            {label: 'Do MMM, YY', value: 'Do MMM, YY'},
                                                                            {label: 'Do MMM, YY h:mm A', value: 'Do MMM, YY h:mm A'},
                                                                        ]}
                                                                    />

                                                                )

                                                            }
                                                                    
                                                            
                                                        </Box>
                                                        
                                                        </>
                                                    )
                                                }

                                                <Box className='re-edit-settings-filter-content-item'>
                                                    <Box className='re-edit-settings-filter-content-item-label-main'>
                                                        <Box>Show total value <IconLabelInfo className='re-edit-settings-filter-content-item-label-about' /></Box>
                                                        <Box>
                                                            <Switch
                                                                checked={field.showTotalValue ? true : false}
                                                                onChange={e => handleFieldChange(e, index, 'showTotalValue')}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    <Box className='re-edit-settings-filter-content-item-options'>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="showTotalValue-label"
                                                            name="showTotalValue"
                                                        >
                                                            <FormControlLabel className='re-form-radio-option' value="Sum" control={<Radio />} label="Sum" />
                                                            <FormControlLabel className='re-form-radio-option' value="Average" control={<Radio />} label="Average" />
                                                            
                                                        </RadioGroup>
                                                    </Box>
                                                </Box>

                                            </Grid>
                                        </Box>
                                    
                                    </Box>
                                    
                                ))
                            }

                        </Box>
                    </ClickAwayListener>
                </Grid> 

                <Grid container >
                    <Grid item xs={12}>
                        <Box className={`re-edit-settings-axis-settings ` + (axisSettingsOpenStatus ? `show` : ``)}>
                            <Box className='re-edit-settings-axis-settings-header' onClick={() => setAxisSettingsOpenStatus(!axisSettingsOpenStatus)}>
                                <Box className='re-edit-settings-axis-settings-header-label'>Axis setting</Box>
                                <DropDownIcon2 className='re-edit-settings-axis-settings-header-icon' />
                            </Box>
                            <Box className={`re-edit-settings-axis-settings-content `}>
                                <Box className={`re-edit-settings-axis-settings-item ` + (XAxisSettingsOpenStatus ? `show` : ``)}>
                                    <Box className='re-edit-settings-axis-settings-item-header' onClick={() => setXAxisSettingsOpenStatus(!XAxisSettingsOpenStatus)}>
                                        <Box className='re-edit-settings-axis-settings-item-header-label'>X-Axis</Box>
                                        <DropDownIcon2 className='re-edit-settings-axis-settings-item-header-icon' />
                                    </Box>
                                    <Box className='re-edit-settings-axis-settings-item-content'>
                                        <TextField
                                            name={'xAxisLabelName'}
                                            placeholder='Label Name'
                                            className="re-form-input re-form-input-light"
                                            value={``}
                                            onChange={e => handleFieldChange(e, null, 'xAxisLabelName')}
                                        />
                                    </Box>
                                </Box>

                                <Box className={`re-edit-settings-axis-settings-item mb-0 ` + (YaxisSettingsOpenStatus ? `show` : ``)}>
                                    <Box className='re-edit-settings-axis-settings-item-header' onClick={() => setYAxisSettingsOpenStatus(!YaxisSettingsOpenStatus)}>
                                        <Box className='re-edit-settings-axis-settings-item-header-label'>Y-Axis</Box>
                                        <DropDownIcon2 className='re-edit-settings-axis-settings-item-header-icon' />
                                    </Box>
                                    <Box className='re-edit-settings-axis-settings-item-content'>
                                        <RadioGroup
                                            className='re-edit-settings-axis-settings-item-option'
                                            row
                                            aria-labelledby="yAxisValueType-label"
                                            name="yAxisValueType"
                                            onChange={(e) => setYAxisValueType(e.target.value)}
                                        >
                                            <FormControlLabel className='re-form-radio-option' checked={yAxisValueType === 'Single'} value="Single" control={<Radio />} label="Single" />
                                            <FormControlLabel className='re-form-radio-option' checked={yAxisValueType === 'Multiple'} value="Multiple" control={<Radio />} label="Multiple" />
                                            
                                        </RadioGroup>
                                        {
                                            (yAxisValueType === 'Single')
                                                ?   <Box className=''>
                                                        <TextField
                                                            name={'YAxisLabelName'}
                                                            placeholder='Label Name'
                                                            className="re-form-input re-form-input-light"
                                                            value={``}
                                                            onChange={e => handleFieldChange(e, null, 'YAxisLabelName')}
                                                        />
                                                        <Box className='re-edit-settings-axis-settings-item-option-item'>
                                                            <Box className=''>
                                                                <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                                    icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                                    //checked={} 
                                                                    />}
                                                                    label={'Interval'} />
                                                            </Box>
                                                            <Box className=''>
                                                                <TextField 
                                                                    name={'YAxisSingleInterval'}
                                                                    type="number"
                                                                    placeholder='0'
                                                                    className="re-form-input re-form-input-light re-form-input-xs"
                                                                    value={``}
                                                                    onChange={e => handleFieldChange(e, null, 'YAxisSingleInterval')}
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Box className='re-edit-settings-axis-settings-item-option-item'>
                                                            <Box className=''>
                                                                <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                                    icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                                    //checked={} 
                                                                    />}
                                                                    label={'Max Value'} />
                                                            </Box>
                                                            <Box className=''>
                                                                <TextField 
                                                                    name={'YAxisSingleMaxVal'}
                                                                    type="number"
                                                                    placeholder='0'
                                                                    className="re-form-input re-form-input-light re-form-input-xs"
                                                                    value={``}
                                                                    onChange={e => handleFieldChange(e, null, 'YAxisSingleMaxVal')}
                                                                />
                                                            </Box>
                                                        </Box>

                                                        <Box className='re-edit-settings-axis-settings-item-option-item contentBlock'>
                                                            <Box className='re-edit-settings-axis-settings-item-option-item-label'>Format </Box>
                                                            <Box className='re-edit-settings-axis-settings-item-option-item-options' >

                                                                <CustomSelect
                                                                    label='Format'
                                                                    value={'Number'}
                                                                    handleSelectedValue={e => null}
                                                                    optionLabels={{label: 'label', value: 'value'}}
                                                                    options={[
                                                                        {label: 'Number', value: 'number'},
                                                                        {label: 'Compact Number', value: 'compactNumber'},
                                                                        {label: 'Percent', value: 'percent'},
                                                                        {label: 'Hours', value: 'hour'},
                                                                        {label: 'Minutes', value: 'minute'},
                                                                        {label: 'Seconds', value: 'second'},
                                                                        {label: 'Currency (INR)', value: 'INR'},
                                                                        {label: 'Currency (USD)', value: 'USD'},
                                                                        {label: 'Compact Currency (INR)', value: 'compactINR'},
                                                                        {label: 'Compact Currency (USD)', value: 'compactUSD'},
                                                                    ]}
                                                                />
                                                                
                                                                

                                                            </Box>
                                                        </Box>
                                                    </Box>

                                                :   <Box className=''>
                                                        
                                                        <Box className='yAxisMulitpleItem'>
                                                            <Box className='re-edit-settings-axis-multiple-label'>First Axis</Box>
                                                            <TextField 
                                                                name={'YAxisMultipleLabelName'}
                                                                placeholder='Label Name'
                                                                className="re-form-input re-form-input-light"
                                                                value={``}
                                                                onChange={e => handleFieldChange(e, null, 'YAxisMultipleLabelName')}
                                                            />
                                                            <CustomSelect
                                                                theme="light"
                                                                label='Select Field'
                                                                value={''}
                                                                handleSelectedValue={e => null}
                                                                optionLabels={{label: 'label', value: 'value'}}
                                                                options={[
                                                                    {label: 'None', value: ''},
                                                                    {label: '10', value: '10'},
                                                                    {label: '20', value: '20'},
                                                                    {label: '30', value: '30'},
                                                                ]}
                                                            />
                                                            <Box className='re-edit-settings-axis-settings-item-option-item'>
                                                                <Box className=''>
                                                                    <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                                        icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                                        //checked={} 
                                                                        />}
                                                                        label={'Interval'} />
                                                                </Box>
                                                                <Box className=''>
                                                                    <TextField 
                                                                        name={'YAxisSingleInterval'}
                                                                        type="number"
                                                                        placeholder='0'
                                                                        className="re-form-input re-form-input-light re-form-input-xs"
                                                                        value={``}
                                                                        onChange={e => handleFieldChange(e, null, 'YAxisSingleInterval')}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                            <Box className='re-edit-settings-axis-settings-item-option-item'>
                                                                <Box className=''>
                                                                    <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                                        icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                                        //checked={} 
                                                                        />}
                                                                        label={'Max Value'} />
                                                                </Box>
                                                                <Box className=''>
                                                                    <TextField 
                                                                        name={'YAxisSingleMaxVal'}
                                                                        type="number"
                                                                        placeholder='0'
                                                                        className="re-form-input re-form-input-light re-form-input-xs"
                                                                        value={``}
                                                                        onChange={e => handleFieldChange(e, null, 'YAxisSingleMaxVal')}
                                                                    />
                                                                </Box>
                                                            </Box>

                                                            <Box className='re-edit-settings-axis-settings-item-option-item contentBlock'>
                                                                <Box className='re-edit-settings-axis-settings-item-option-item-label'>Format </Box>
                                                                <Box className='re-edit-settings-axis-settings-item-option-item-options' >

                                                                    <CustomSelect
                                                                        label='Format'
                                                                        value={'Number'}
                                                                        handleSelectedValue={e => null}
                                                                        optionLabels={{label: 'label', value: 'value'}}
                                                                        options={[
                                                                            {label: 'Number', value: 'number'},
                                                                            {label: 'Compact Number', value: 'compactNumber'},
                                                                            {label: 'Percent', value: 'percent'},
                                                                            {label: 'Hours', value: 'hour'},
                                                                            {label: 'Minutes', value: 'minute'},
                                                                            {label: 'Seconds', value: 'second'},
                                                                            {label: 'Currency (INR)', value: 'INR'},
                                                                            {label: 'Currency (USD)', value: 'USD'},
                                                                            {label: 'Compact Currency (INR)', value: 'compactINR'},
                                                                            {label: 'Compact Currency (USD)', value: 'compactUSD'},
                                                                        ]}
                                                                    />
                                                                    
                                                                    

                                                                </Box>
                                                            </Box>
                                                        </Box>

                                                        <Box className='divider'></Box>

                                                        <Box className='yAxisMulitpleItem'>
                                                            <Box className='re-edit-settings-axis-multiple-label'>Second Axis</Box>
                                                            <TextField 
                                                                name={'YAxisMultipleLabelName'}
                                                                placeholder='Label Name'
                                                                className="re-form-input re-form-input-light"
                                                                value={``}
                                                                onChange={e => handleFieldChange(e, null, 'YAxisMultipleLabelName')}
                                                            />
                                                            <CustomSelect
                                                                theme="light"
                                                                label='Select Field'
                                                                value={''}
                                                                handleSelectedValue={e => null}
                                                                optionLabels={{label: 'label', value: 'value'}}
                                                                options={[
                                                                    {label: 'None', value: ''},
                                                                    {label: '10', value: '10'},
                                                                    {label: '20', value: '20'},
                                                                    {label: '30', value: '30'},
                                                                ]}
                                                            />
                                                            <Box className='re-edit-settings-axis-settings-item-option-item'>
                                                                <Box className=''>
                                                                    <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                                        icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                                        //checked={} 
                                                                        />}
                                                                        label={'Interval'} />
                                                                </Box>
                                                                <Box className=''>
                                                                    <TextField 
                                                                        name={'YAxisSingleInterval'}
                                                                        type="number"
                                                                        placeholder='0'
                                                                        className="re-form-input re-form-input-light re-form-input-xs"
                                                                        value={``}
                                                                        onChange={e => handleFieldChange(e, null, 'YAxisSingleInterval')}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                            <Box className='re-edit-settings-axis-settings-item-option-item'>
                                                                <Box className=''>
                                                                    <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                                        icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                                        //checked={} 
                                                                        />}
                                                                        label={'Max Value'} />
                                                                </Box>
                                                                <Box className=''>
                                                                    <TextField 
                                                                        name={'YAxisSingleMaxVal'}
                                                                        type="number"
                                                                        placeholder='0'
                                                                        className="re-form-input re-form-input-light re-form-input-xs"
                                                                        value={``}
                                                                        onChange={e => handleFieldChange(e, null, 'YAxisSingleMaxVal')}
                                                                    />
                                                                </Box>
                                                            </Box>

                                                            <Box className='re-edit-settings-axis-settings-item-option-item contentBlock'>
                                                                <Box className='re-edit-settings-axis-settings-item-option-item-label'>Format </Box>
                                                                <Box className='re-edit-settings-axis-settings-item-option-item-options' >

                                                                    <CustomSelect
                                                                        label='Format'
                                                                        value={'Number'}
                                                                        handleSelectedValue={e => null}
                                                                        optionLabels={{label: 'label', value: 'value'}}
                                                                        options={[
                                                                            {label: 'Number', value: 'number'},
                                                                            {label: 'Compact Number', value: 'compactNumber'},
                                                                            {label: 'Percent', value: 'percent'},
                                                                            {label: 'Hours', value: 'hour'},
                                                                            {label: 'Minutes', value: 'minute'},
                                                                            {label: 'Seconds', value: 'second'},
                                                                            {label: 'Currency (INR)', value: 'INR'},
                                                                            {label: 'Currency (USD)', value: 'USD'},
                                                                            {label: 'Compact Currency (INR)', value: 'compactINR'},
                                                                            {label: 'Compact Currency (USD)', value: 'compactUSD'},
                                                                        ]}
                                                                    />
                                                                    
                                                                    

                                                                </Box>
                                                            </Box>
                                                        </Box>

                                                        <Box className='divider'></Box>
                                                        
                                                        <Box className='re-edit-settings-axis-settings-item-add-btn'>
                                                            <IconFilterItemAdd />
                                                            <Box className='re-edit-settings-axis-settings-item-add-btn-label'>Add Third Axis</Box>
                                                        </Box>
                                                    </Box>
                                        }
                                        
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                <Grid>
                    <Box className='re-edit-settings-hyperlink-option'>
                        <Box className='re-edit-settings-filter-content-item mb-0'>
                        <Box className='re-edit-settings-filter-content-item-label-main'>
                            <Box>Hyperlink <IconLabelInfo className='re-edit-settings-filter-content-item-label-about' /></Box>
                            <Box><IconFilterItemAdd className='re-edit-settings-filter-content-item-link-icon' /></Box>
                        </Box>
                        <Box className='re-edit-settings-filter-content-item-link' onClick={() => null}>+ Add Hyperlink</Box>
                        
                    </Box>
                    </Box>
                </Grid>

                <Grid >
                    <Box className='re-edit-settings-value-option'>
                            <Box className='re-edit-settings-value-option-heading'>
                                <Box className='re-edit-settings-value-option-heading-label'>Show Absolute value</Box>
                                <Box>
                                    <Switch
                                        checked={hasAbsoluteValue ? true : false}
                                        onChange={e => setHasAbsoluteValue(!hasAbsoluteValue)}
                                    />
                                </Box>
                            </Box>
                            <Box className={`re-edit-settings-value-option-content ` + (hasAbsoluteValue ? `has-absolute-value` : ``)}>
                                <Box className='mb-1'>
                                    <CustomSelect
                                        label='Select Data Field'
                                        value={''}
                                        handleSelectedValue={(e) => null}
                                        optionLabels={{label: 'label', value: 'value'}}
                                        options={[
                                            {label: '10', value: 10},
                                            {label: '20', value: 20},
                                            {label: '50', value: 50},
                                        ]}
                                    />
                                </Box>

                               <Box className='mb-1'>
                                <RadioGroup
                                        row
                                        aria-labelledby="showTotalValue-label"
                                        name="showTotalValue"
                                    >
                                        <FormControlLabel className='re-form-radio-option' value="Sum" control={<Radio />} label="Sum" />
                                        <FormControlLabel className='re-form-radio-option' value="Average" control={<Radio />} label="Average" />
                                        
                                    </RadioGroup>
                               </Box>

                                <Box className=''>
                                    <TextField
                                        name={'absoluteValueName'}
                                        placeholder='Value Name'
                                        className="re-form-input"
                                        value={``}
                                        onChange={e => handleFieldChange(e, null, 'absoluteValueName')}
                                    />
                                </Box>
                            </Box>
                    </Box>
                </Grid>
                <Grid container alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h4" component="div" className="re-edit-settings-input-label">Web Setting</Typography>
                        <Box className="re-edit-settings-options" >

                            <Box className="re-edit-settings-options-container">
                                <Box className='re-edit-settings-options-label'>Display</Box>

                                <Box className='re-edit-settings-options-content'>
                                    <Box className='re-edit-settings-options-content-item'>
                                        <Box className=''>
                                            <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                //checked={} 
                                                />}
                                                label={'Background color'} />
                                        </Box>
                                        <Box className=''>
                                            <TextField className='re-form-input-color' sx={{backgroundColor: reportDetails?.settings?.web?.reportGridBgColor}}  type="color" defaultValue={'#FFFFFF'} />
                                        </Box>
                                    </Box>

                                    <Box className='re-edit-settings-options-content-item'>
                                        <Box className=''>
                                            <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                //checked={} 
                                                />}
                                                label={'Grid Color'} />
                                        </Box>
                                        <Box className=''>
                                            <TextField className='re-form-input-color' sx={{backgroundColor: reportDetails?.settings?.web?.reportGridBgColor}}  type="color" defaultValue={'#FFFFFF'} />
                                        </Box>
                                    </Box>

                                    <Box className='re-edit-settings-options-content-item'>
                                        <Box className=''>
                                            <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                //checked={} 
                                                />}
                                                label={'Border Color'} />
                                        </Box>
                                        <Box className=''>
                                            <TextField className='re-form-input-color' sx={{backgroundColor: reportDetails?.settings?.web?.reportGridBgColor}}  type="color" defaultValue={'#FFFFFF'} />
                                        </Box>
                                    </Box>

                                    <Box className='re-edit-settings-options-content-item'>
                                        <Box className=''>
                                            <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                //checked={} 
                                                />}
                                                label={'Bottom Border for heading'} />
                                            <Box className='re-edit-settings-options-content-item-sublabel'>(Visible in dashboard report)</Box>
                                        </Box>
                                        
                                    </Box>
                                </Box>
                            </Box>
                            

                            <Box className='re-edit-settings-options-content-mobile-heading'>
                                <Box className='re-edit-settings-options-content-mobile-heading-title'>Mobile Setting</Box>
                                <Box>
                                    <Switch
                                        checked={mobileHasSameWebSettings ? true : false}
                                        onChange={e => setMobileHasSameWebSettings(!mobileHasSameWebSettings)}
                                    />
                                </Box>
                            </Box>

                            <Box className='re-edit-settings-options-container'>
                                <Box className='re-edit-settings-filter-content-item'>
                                    <Box className='re-edit-settings-filter-content-item-label-label2'>
                                        <Box>Data value limit upto </Box>
                                    </Box>
                                    <Box className='re-edit-settings-filter-content-item-options'>

                                        <CustomSelect
                                            label='Format'
                                            value={limitValue || null}
                                            handleSelectedValue={(e) => handleReportLimit(e)}
                                            optionLabels={{label: 'label', value: 'value'}}
                                            options={[
                                                {label: '10', value: 10},
                                                {label: '20', value: 20},
                                                {label: '50', value: 50},
                                                {label: '100', value: 100},
                                                {label: '200', value: 200},
                                                {label: '500', value: 500},
                                                {label: '1000', value: 1000},
                                            ]}
                                        />
                                        
                                        

                                    </Box>
                                </Box>
                            </Box>
                            
                            
                        </Box>
                    </Grid>

                    {
                        (!mobileHasSameWebSettings)
                            ?   <Grid item xs={12} className='re-edit-settings-options-mobile-wrapper'>
                                    <Typography variant="h4" component="div" className="re-edit-settings-input-label">Mobile Setting</Typography>
                                    <Box className="re-edit-settings-options" >
            
                                        <Box className="re-edit-settings-options-container">
                                            <Box className='re-edit-settings-options-label'>Display</Box>
            
                                            <Box className='re-edit-settings-options-content'>
                                                <Box className='re-edit-settings-options-content-item'>
                                                    <Box className=''>
                                                        <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                            icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                            //checked={} 
                                                            />}
                                                            label={'Background color'} />
                                                    </Box>
                                                    <Box className=''>
                                                        <TextField className='re-form-input-color' sx={{backgroundColor: reportDetails?.settings?.web?.reportGridBgColor}}  type="color" defaultValue={'#FFFFFF'} />
                                                    </Box>
                                                </Box>
            
                                                <Box className='re-edit-settings-options-content-item'>
                                                    <Box className=''>
                                                        <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                            icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                            //checked={} 
                                                            />}
                                                            label={'Grid Color'} />
                                                    </Box>
                                                    <Box className=''>
                                                        <TextField className='re-form-input-color' sx={{backgroundColor: reportDetails?.settings?.web?.reportGridBgColor}}  type="color" defaultValue={'#FFFFFF'} />
                                                    </Box>
                                                </Box>
            
                                                <Box className='re-edit-settings-options-content-item'>
                                                    <Box className=''>
                                                        <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                            icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                            //checked={} 
                                                            />}
                                                            label={'Border Color'} />
                                                    </Box>
                                                    <Box className=''>
                                                        <TextField className='re-form-input-color' sx={{backgroundColor: reportDetails?.settings?.web?.reportGridBgColor}}  type="color" defaultValue={'#FFFFFF'} />
                                                    </Box>
                                                </Box>
            
                                                <Box className='re-edit-settings-options-content-item'>
                                                    <Box className=''>
                                                        <FormControlLabel className="filters-view-checkbox" control={<Checkbox className="form_checkbox"
                                                            icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                                            //checked={} 
                                                            />}
                                                            label={'Bottom Border for heading'} />
                                                        <Box className='re-edit-settings-options-content-item-sublabel'>(Visible in dashboard report)</Box>
                                                    </Box>
                                                    
                                                </Box>
                                            </Box>
                                        </Box>
                                        
                                        
                                    </Box>
                                </Grid>

                            :   null
                    }

                </Grid>               
            </Box>
        </Box>
    </RootStyle>
}

export default memo(ReportSettingsTab)